import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {},
});
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import { ref } from "vue";

// Reaktif global variable
export const subCompany = ref(null);
const getSafeCompanyId = (data) => {
  try {
    return data ? JSON.parse(data).company_id : null;
  } catch (e) {
    return null;
  }
};

export const getSubCompanyId = ref(getInitialSubDomainId());
export const getChoosedCompany = ref(null);

export function getInitialSubDomainId() {
  const user = ls.get("user");
  const parent = ls.get("parentCompany");
  return getSafeCompanyId(user) ?? getSafeCompanyId(parent);
}
export const parentCompany = ref(null);
export const isHierarchy = ref(false);

export function syncHierarchyFromService(response) {
  const value = Boolean(
    response?.settings?.find((x) => x.key === "hierarchy")?.value
  );

  isHierarchy.value = value;
}
